import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FornecedorService } from 'src/app/service/fornecedor.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Fornecedor } from './fornecedor';
import { ViaCepService } from 'src/app/service/viaCep.service';
import { Utils } from 'src/app/util/utils';
import { CidadeService } from 'src/app/service/cidade.service';
import { EstadosBrasil, NomesEstadosBrasil } from 'src/app/enum/estadosBrasil.enum';

@Component({
  selector: 'app-fornecedor',
  templateUrl: './fornecedor.component.html',
  styleUrls: ['./fornecedor.component.scss']
})
export class FornecedorComponent implements OnInit {

  formulario: FormGroup;
  fornecedores: Fornecedor[] = [];
  //ordem das colunas no html 
  ordemColunasTabela = ['id', 'name', 'telephone', 'address', 'block', 'batch', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; // [10,20,30] quantidade de item por página
  mensagemErros: String[] = []; //array de strings dos erros retornados do backend
  public errorMessage: string = '';
  estados = Object.values(EstadosBrasil);
  cidades: String[] = [];
  tipoFiltro: any;
  tipoFiltros: String[] = ['Fornecedor'];
  dataInicio: any;
  dataFim: any;
  fornecedor: any;
  parametroConsulta: any;


  constructor(
    private fornecedorService: FornecedorService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private viaCepService: ViaCepService,
    private utils: Utils,
    private cidadeService: CidadeService,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.listarFornecedores(this.pagina, this.tamanho);
  }

  submit() {
    //pegar os dados do formulário
    const formValues = this.formulario.value;
    // cria e adiciona no objeto
    const fornecedor: Fornecedor = new Fornecedor(
      formValues.id,
      formValues.nomeFantasia,
      formValues.razaoSocial,
      formValues.address,
      formValues.block,
      formValues.batch,
      formValues.telephone,
      formValues.complement,
      formValues.observation,
      formValues.bairro,
      formValues.cidade,
      formValues.estado,
      formValues.cep
    );

    if (formValues.id) {
      this.fornecedorService.update(fornecedor).subscribe(resposta => {
        this.listarFornecedores(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Produto alterado com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse, 'ERRO', {
          duration: 2000
        })
      })
    } else {
      // cria e adiciona no objeto
      this.fornecedorService.save(fornecedor).subscribe(resposta => {
        this.listarFornecedores(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Cliente salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse, 'ERRO', {
          duration: 2000
        })
      })
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      nomeFantasia: [null, [Validators.minLength(3), Validators.maxLength(250)]],
      razaoSocial: [null, Validators.nullValidator],
      telephone: [null, Validators.nullValidator],
      address: [null, Validators.nullValidator],
      block: [null, Validators.nullValidator],
      batch: [null, Validators.nullValidator],
      complement: [null],
      observation: [null],
      estado: [null, Validators.nullValidator],
      bairro: [null, Validators.nullValidator],
      cidade: [null],
      cep: [null],

    })
  }

  limparFormulario() {
    this.formulario.reset();
  }

  listarFornecedores(pagina: number, tamanho: number) {// definir a primeira página e o tamanho inicial
    this.fornecedorService.list(pagina, tamanho).subscribe((response) => {
      this.fornecedores = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

  private excluir(id: number) {
    this.fornecedorService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      // exibir mensagem snackbar
      this.snackBar.open('Producto excluido com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      // exibe mensagem de erro da api
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }

  editar(id: number) {
    this.fornecedorService.findFornecedorById(id).subscribe((response) => {
      // cria e adiciona no objeto
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.razaoSocial.setValue(response.razaoSocial);
      this.formulario.controls.nomeFantasia.setValue(response.nomeFantasia);
      this.formulario.controls.address.setValue(response.address);
      this.formulario.controls.block.setValue(response.block);
      this.formulario.controls.batch.setValue(response.batch);
      this.formulario.controls.telephone.setValue(response.telephone);
      this.formulario.controls.complement.setValue(response.complement);
      this.formulario.controls.observation.setValue(response.observation);
      this.formulario.controls.cidade.setValue(response.cidade);
      this.formulario.controls.estado.setValue(response.estado);
      this.formulario.controls.bairro.setValue(response.bairro);
      this.formulario.controls.cep.setValue(response.cep);
    })
  }

  //chamar a paginação
  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarFornecedores(this.pagina, this.tamanho);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      // se clicar em ok chama evento de excluir
      if (result) {
        this.excluir(id);
      }
    });
  }

  buscarDadosCep(): void {
    this.mostrarLoading();
    if (!this.utils.isNullOrEmpty(this.formulario.get('cep')?.value)) {
      this.viaCepService.buscarCep(this.formulario.get('cep')?.value).subscribe(resposta => {
        this.formulario.controls['estado']!.setValue(resposta.estado);
        this.formulario.controls['cidade']!.setValue(resposta.localidade);
        this.formulario.controls['bairro']!.setValue(resposta.bairro);
        this.formulario.controls['address']!.setValue(resposta.logradouro);
        this.buscarMunicipios(this.buscarSiglaEstadoInformado(resposta.estado));
      }, errorResponse => {
        this.formulario.controls['estado']!.setValue('');
        this.formulario.controls['cidade']!.setValue('');
        this.formulario.controls['bairro']!.setValue('');
        this.formulario.controls['address']!.setValue('');
        this.fecharLoading();
      });
    } else {
      this.formulario.controls['estado']!.setValue('');
      this.formulario.controls['cidade']!.setValue('');
      this.formulario.controls['bairro']!.setValue('');
      this.formulario.controls['address']!.setValue('');
      this.fecharLoading();
    }
    this.fecharLoading();
  }

  buscarMunicipios(uf: string): void {
    this.mostrarLoading();
    if (!this.utils.isNullOrEmpty(uf)) {
      this.cidadeService.buscarMunicipios(uf).subscribe(resposta => {
        this.cidades = resposta;
        this.fecharLoading();
      }, errorResponse => {
        this.fecharLoading();
      });
    } else {
      this.fecharLoading();
    }
  }

  removeAcento(texto: string): string {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  validateInputEstado(): void {
    const formValues = this.formulario.value;
    const encontrado = this.estados.filter(item => this.removeAcento(item.toLowerCase()) === this.removeAcento(formValues.estado.trim().toLowerCase()));
    if (formValues.estado && !encontrado) {
      this.errorMessage = `O valor não está na lista de opções.`;
    } else {
      this.formulario.controls['estado']!.setValue(encontrado[0]);
      this.buscarMunicipios(this.buscarSiglaEstadoInformado(encontrado[0]));
      this.errorMessage = '';
    }
  }

  buscarSiglaEstadoInformado(estado: string): string {
    if (!this.utils.isNullOrEmpty(estado)) {
      const sigla = Object.entries(EstadosBrasil).find(
        ([, nome]) => nome.toLowerCase() === estado.toLowerCase()
      )?.[0];
      return sigla || '';
    }
    return '';
  }

  public mostrarLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:block;");
  }
  public fecharLoading() {
    let load = document.getElementById('preloader');
    load?.setAttribute("style", "display:none;");
  }

  getSiglaEstado(estado: EstadosBrasil) {
    return NomesEstadosBrasil.get(estado);
  }

  consultar() {
    if (this.parametroConsulta != null) {
      this.fornecedorService.findFornecedores(this.pagina, this.tamanho, this.tipoFiltro, this.parametroConsulta).subscribe((response) => {
        this.fornecedores = response.content; // pegar o conteudo do pag
        this.totalElementos = response.totalElements;// pegar o total de elementos
        this.pagina = response.number;// pegar o numero de paginas
      });
    } else {
      this.listarFornecedores(this.pagina, this.tamanho);
    }
  }



}

